export default "Isolation des murs (ITI / ITE) 2026 — Aides MPR + CEE | Solution Éco France";
